import React from "react";
import { Box, SpaceBetween } from "@cloudscape-design/components";
import Icon from "@cloudscape-design/components/icon";
import SectionHeader from "../../common/SectionHeader";
import RevenueCards from "../RevenueCards";
import HorizontalCardContainer from "src/components/common/HorizontalCardContainer";
import Badge from "../../common/Badge";

const KeyMetricsSection: React.FC = () => {
  return (
    <Box>
      <SpaceBetween size="xs">
        <SectionHeader
          title="Key Metrics"
          variant="h2"
          icon={<Icon name="status-info" />}
          useGradient={true}
        />
        <Box color="text-body-secondary" fontSize="body-s" padding={{ bottom: "s" }}>
          Metrics displayed are for WW Stores (North America Established, EU10, IES, JP - Japan)
        </Box>
      </SpaceBetween>
      <div style={{ marginTop: "-12px" }}>
        <HorizontalCardContainer ariaLabel="Featured cards horizontal scroll">
          <RevenueCards />
        </HorizontalCardContainer>
      </div>
    </Box>
  );
};

export default KeyMetricsSection;
